import { getMetaContent } from "./Utils";

const constants = {

    serverRoot       : getMetaContent('server-root' ).replace(/\/$/, ''),
    serverUrl        : getMetaContent('context-path').replace(/\/$/, ''),
    recaptchaSiteKey : "6LdETiopAAAAAOxqSVO9T2z5tSErldM_Uner5CfS",
    
    updateOptions: {
        none: 'none',
        replace: 'replace',
        merge: 'merge',
        mergeAppend: 'mergeAppend',
        mergePrepend: 'mergePrepend',
    },
};

export default Object.freeze(constants)
